import React from "react";
import {Button, Checkbox, Container, Form, Grid, Icon} from "semantic-ui-react";
import {getStaffList} from "../../../Api/Api";
import ProgressContainer from "../../Progress/ProgressContainer";

class Target extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        getStaffList().then(data => {
            if(data){
                this.props.setTargets(data);
            }
        });

        this.props.scrollToStep(3);
    }

    addCheckbox = (targets) => {
        return (
            targets.map((val)=> {
                return (
                    <Form.Field>
                        <Checkbox
                            radio
                            label={val.country}
                            name='checkboxRadioGroup'
                            value={val.value}
                            checked={this.props.flow.targetID === val.value}
                            onChange={this.props.ChooseTarget}
                            target = 'targetID'
                        />
                    </Form.Field>
                )
            })
        )
    };

    render() {
        let disabled = false;
        if (!this.props.flow.targetID) {
            disabled = true;
        }

        return (
                <Grid id={'target'} className={'step-section'}>
                    <Grid.Column padded={'horizontally'}>
                        <Container className={"pre-header"}>
                            <h2>IT Team Cost Calculator</h2>
                            <h4>With Intersog, you get access to <strong>250+</strong> top software developers ready to commit from day one.</h4>
                        </Container>
                        <ProgressContainer/>
                        <Container className={"main"}>
                            <h3>Where do you want your IT hires to be located?</h3>
                            <Container className={"target"}>
                                <Form>
                                    {this.addCheckbox(this.props.flow.targets)}
                                </Form>
                            </Container>
                            <Container className={"navigation"}>
                                <Button className={`intersog-btn left inverse`} onClick={() =>{this.props.scrollToStep(2);}}>
                                    Back
                                </Button>
                                <Button className={`intersog-btn right`} onClick={() =>{this.props.setNextStep(4);this.props.changeStep();this.props.scrollToStep(4);}} disabled={disabled}>
                                    Next
                                </Button>
                            </Container>
                        </Container>
                    </Grid.Column>
                </Grid>
        );
    }
}


export default Target;